import TopHeader from "../components/TopHeader";
import Footer from "../components/Footer";

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <TopHeader />
      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full">
        <h1 className="text-3xl font-bold text-foreground mb-2">Refund Policy</h1>
        <p className="text-muted-foreground text-sm mb-10">Last updated: May 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8 text-foreground/90 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Overview</h2>
            <p>
              We want you to be completely satisfied with your purchase. If you are not happy
              with our product, we offer refunds under the conditions described below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Eligibility for Refunds</h2>
            <p>
              Refunds are available within <strong>7 days</strong> of purchase if the product
              does not work as described. To be eligible:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-foreground/80">
              <li>Your refund request must be submitted within 7 days of the original purchase date.</li>
              <li>You must provide a brief description of the issue you experienced.</li>
              <li>Refunds are issued to the original payment method.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Subscriptions</h2>
            <p>
              You may cancel your Pro subscription at any time. Cancellations take effect at the
              end of the current billing period — you will not be charged again after cancellation,
              and you retain access to Pro features until the period ends.
            </p>
            <p className="mt-3">
              Partial refunds for unused subscription time are not provided unless the service
              was unavailable for an extended period due to our fault.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Pay-Per-Use Credits</h2>
            <p>
              One-time conversion credit purchases are non-refundable once credits have been used.
              If you purchased credits and have not used any, you may request a refund within 7 days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">How to Request a Refund</h2>
            <p>
              To request a refund, email us at{" "}
              <a href="mailto:sufyameher@gmail.com" className="text-primary underline">
                sufyameher@gmail.com
              </a>{" "}
              with:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-foreground/80">
              <li>Your order ID or the email used for purchase</li>
              <li>The reason for your refund request</li>
            </ul>
            <p className="mt-3">
              We aim to respond within 2 business days. Approved refunds are processed within
              5–10 business days depending on your payment provider.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Contact</h2>
            <p>
              If you have any questions about this policy, contact us at{" "}
              <a href="mailto:sufyameher@gmail.com" className="text-primary underline">
                sufyameher@gmail.com
              </a>.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
